import { getUrl } from './API';

export const signInWithWhatsapp = async function () {
  const apiRes = await getUrl();
  if (apiRes?.data && apiRes?.data?.redirectionURL) {
    window.location.replace(apiRes?.data?.redirectionURL);
    window.focus();
  }
};
